import { C, STEPS } from "../data/constants";

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="section-pad" style={{ background: C.cream }}>
      <div className="container">
        <div className="section-header fade">
          <p style={{ color: C.blush, letterSpacing: 3, textTransform: "uppercase", fontSize: 11, marginBottom: 10 }}>Simple Process</p>
          <h2 style={{ fontSize: "clamp(28px,4vw,48px)", fontWeight: 300, color: C.dark, marginBottom: 14 }}>How We Work Together</h2>
          <div style={{ width: 48, height: 1, background: C.blush, margin: "0 auto" }} />
        </div>

        <div className="steps-grid">
          {STEPS.map((s, i) => (
            <div key={i} className="fade" style={{ textAlign: "center", padding: "0 12px" }}>
              <div style={{ fontSize: "clamp(48px,7vw,64px)", fontFamily: "'Cormorant Garamond',serif", color: C.blush, opacity: 0.4, lineHeight: 1, marginBottom: 16 }}>{s.num}</div>
              <h3 style={{ fontSize: "clamp(18px,2.5vw,24px)", fontWeight: 600, color: C.dark, marginBottom: 12 }}>{s.title}</h3>
              <p style={{ color: C.mid, lineHeight: 1.8, fontSize: "clamp(13px,1.5vw,15px)" }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}